import React from 'react';
import { AvatarLarge, AvatarMedium, ResponsiveImage } from '../../components';

import css from './ListingPage.module.css';

const SectionAvatar = props => {
  const { user, isOffer, listing } = props;


  const firstImage = !!listing?.images?.length > 0 ? listing.images[0] : null;

  if (isOffer) {
    return (
      <div className={css.sectionAvatar}>
        <ResponsiveImage
          rootClassName={css.offerLogo}
          alt={listing?.attributes?.title}
          image={firstImage}
          variants={['scaled-small','landscape-crop','square-small']}
          sizes={"96px"}
        />
      </div>
    );
  } else {
    return (
      <div className={css.sectionAvatar}>
        <AvatarLarge
          user={user}
          className={css.avatarDesktop}
          initialsClassName={css.initialsDesktop}
          disableProfileLink
          isRectangleVariants
        />

        <AvatarMedium user={user} className={css.avatarMobile} disableProfileLink isRectangleVariants />
      </div>
    );
  }

};

export default SectionAvatar;

